import { inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { TermsService } from '../services/terms.service';

@Injectable({
  providedIn: 'root',
})
export class TermsFacade {
  private readonly injector: Injector = inject(Injector);
  private termsService: TermsService | undefined;

  public get getTermsService(): TermsService {
    if (!this.termsService) {
      this.termsService = this.injector.get(TermsService);
    }
    return this.termsService;
  }

  postAcceptTermsOfUse(data: any): Observable<any> {
    return this.getTermsService.postAcceptTerms(data);
  }
}
